import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

export default props => {
  const mode = props.mode;

  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }

  if (mode === "small") {
    return (
      <Translation>
        {t => (
          <table className="table-list-simple">
            <thead>
              <tr>
                <th>{t("common.name")}</th>
                <th>{t("common.key")}</th>
                <th className="last">{t("common.created")}</th>
              </tr>
            </thead>
            <tbody>
              {props.data.map(item => {
                return (
                  <tr key={item.key}>
                    <td className="important">
                      <Link to={`/assets/${item.key}`}>{item.name}</Link>
                    </td>
                    <td>
                      <Link to={`/assets/${item.key}`}>{item.key}</Link>
                    </td>
                    <td className="last">
                      <Link to={`/assets/${item.key}`}>
                        {DateHelper.toLocalString(item.created)}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <table className="table-list-simple">
          <thead>
            <tr>
              <th>{t("common.asset")}</th>
              <th>{t("common.key")}</th>
              <th>{t("common.site")}</th>
              <th className="last">{t("common.created")}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map(item => {
              return (
                <tr key={item.key}>
                  <td className="important">
                    <Link to={`/assets/${item.key}`}>
                      {item.location ? (
                        <img
                          alt={item.phone}
                          src={item.location}
                          className="avatar-small"
                        />
                      ) : (
                        item.phone
                      )}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/assets/${item.key}`}>{item.key}</Link>
                  </td>
                  <td>
                    <Link to={`/sites/${item.site}`}>{item.site_name}</Link>
                  </td>
                  <td className="last">
                    <Link to={`/assets/${item.key}`}>
                      {DateHelper.toLocalString(item.created)}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Translation>
  );
};
